module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Do & Cargo Arrival notice (Documentation)")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    staticStyle: {
      "background": "darkcyan !important",
      "overflow": "visible"
    },
    attrs: {
      "id": "showVisibility"
    },
    on: {
      "click": _vm.showOverflow
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("DOCUMENTATION - RELEASE DELIVERY ORDER")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [(_vm.multiHAWBL.length > 0 || _vm.NocModel.ffDoId != '') ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Current Date & Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.NocModel.currentDate),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "currentDate", $$v)
      },
      expression: "NocModel.currentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.NocModel.ffDoId == '') ? _c('label', [_vm._v("HBL Number")]) : _vm._e(), _vm._v(" "), (_vm.NocModel.ffDoId == '') ? _c('model-list-select', {
    attrs: {
      "option-value": "ffAirMultiBlId",
      "option-text": "secondBLNumber",
      "list": _vm.HAWBLNoList,
      "placeholder": "Select HAWBL No."
    },
    model: {
      value: (_vm.NocModel.ffAirMultiBlId),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "ffAirMultiBlId", $$v)
      },
      expression: "NocModel.ffAirMultiBlId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "hblNo",
      "name": "hblNo",
      "disabled": ""
    },
    model: {
      value: (_vm.NocModel.hblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "hblNo", $$v)
      },
      expression: "NocModel.hblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Importer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.NocModel.importerName),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "importerName", $$v)
      },
      expression: "NocModel.importerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo",
      "name": "mblNo"
    },
    model: {
      value: (_vm.NocModel.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "mblNo", $$v)
      },
      expression: "NocModel.mblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No./ Seal No.")]), _vm._v(" "), _c('quill-editor', {
    ref: "containerSealNo",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.NocModel.containerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "containerSealNo", $$v)
      },
      expression: "NocModel.containerSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Documentation Release Delievery Order")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "400px !important"
    },
    model: {
      value: (_vm.NocModel.nocPreparation),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "nocPreparation", $$v)
      },
      expression: "NocModel.nocPreparation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderNoc"
    },
    on: {
      "click": _vm.addNocDocumentation
    }
  }, [_vm._v("Save & Submit DO Order")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderNoc"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.DODocArray.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("HAWBL No.")]), _vm._v(" "), _c('th', [_vm._v("Importer Name")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.DODocArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.hblNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.importerName))]), _vm._v(" "), _c('td', [_c('b-button', {
      staticClass: "ml-2",
      attrs: {
        "variant": "outline-dark",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.viewEdit(item)
        }
      }
    }, [_vm._v("\n                                  View / Edit\n                                ")]), _vm._v(" "), _c('b-button', {
      staticClass: "ml-2",
      attrs: {
        "variant": "outline-dark",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.Print('AIR_IMPORT_DO_DOC_PDF', item.uploadNocDoc)
        }
      }
    }, [_vm._v("\n                                  PDF\n                                ")])], 1)])
  }))])])]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-viewport",
    attrs: {
      "id": "railOut"
    }
  }, [_c('div', [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    staticStyle: {
      "background": "darkcyan !important",
      "overflow": "visible"
    },
    attrs: {
      "id": "showvehicleBooking"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Documentation ­- Cargo Arrival notice")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [(_vm.HAWBLNoListCargo.length > 0 || _vm.AuthModel.ffCargoId != '') ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Current Date & Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.AuthModel.currentDate),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "currentDate", $$v)
      },
      expression: "AuthModel.currentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Important Notice")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "160px !important"
    },
    model: {
      value: (_vm.AuthModel.importantNotice),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "importantNotice", $$v)
      },
      expression: "AuthModel.importantNotice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Notice Text")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "90px !important"
    },
    model: {
      value: (_vm.AuthModel.noticeText),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "noticeText", $$v)
      },
      expression: "AuthModel.noticeText"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.AuthModel.ffCargoId == '') ? _c('label', [_vm._v("HBL Number")]) : _vm._e(), _vm._v(" "), (_vm.AuthModel.ffCargoId == '') ? _c('model-list-select', {
    attrs: {
      "option-value": "ffAirMultiBlId",
      "option-text": "secondBLNumber",
      "list": _vm.HAWBLNoListCargo,
      "placeholder": "Select HAWBL No."
    },
    model: {
      value: (_vm.AuthModel.ffAirMultiBlId),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "ffAirMultiBlId", $$v)
      },
      expression: "AuthModel.ffAirMultiBlId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "hblNo",
      "name": "hblNo",
      "disabled": ""
    },
    model: {
      value: (_vm.AuthModel.secondBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "secondBLNumber", $$v)
      },
      expression: "AuthModel.secondBLNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo1",
      "name": "mblNo1"
    },
    model: {
      value: (_vm.AuthModel.exporterName),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "exporterName", $$v)
      },
      expression: "AuthModel.exporterName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MBL NO")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo1",
      "name": "mblNo1"
    },
    model: {
      value: (_vm.AuthModel.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "mblNo", $$v)
      },
      expression: "AuthModel.mblNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Airline Line Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.AuthModel.shippingLineName),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "shippingLineName", $$v)
      },
      expression: "AuthModel.shippingLineName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Consigned to.")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "containerSealNo",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.consignedTo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "consignedTo", $$v)
      },
      expression: "AuthModel.consignedTo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voyage")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "containerSealNo",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.vesselNameVoyage),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "vesselNameVoyage", $$v)
      },
      expression: "AuthModel.vesselNameVoyage"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "containerSealNo",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.containerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "containerSealNo", $$v)
      },
      expression: "AuthModel.containerSealNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Origin")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Origin",
      "name": "Origin"
    },
    model: {
      value: (_vm.AuthModel.Origin),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "Origin", $$v)
      },
      expression: "AuthModel.Origin"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Destination",
      "name": "Destination"
    },
    model: {
      value: (_vm.AuthModel.Destination),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "Destination", $$v)
      },
      expression: "AuthModel.Destination"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CBM")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.AuthModel.Measurement),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "Measurement", $$v)
      },
      expression: "AuthModel.Measurement"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("SMTP No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "smtpNo",
      "name": "smtpNo"
    },
    model: {
      value: (_vm.AuthModel.smtpNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "smtpNo", $$v)
      },
      expression: "AuthModel.smtpNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "gatewayIgmNo",
      "name": "gatewayIgmNo"
    },
    model: {
      value: (_vm.AuthModel.gatewayIgmNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "gatewayIgmNo", $$v)
      },
      expression: "AuthModel.gatewayIgmNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("IGM Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a"
    },
    model: {
      value: (_vm.AuthModel.gatewayIgmDate),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "gatewayIgmDate", $$v)
      },
      expression: "AuthModel.gatewayIgmDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a"
    },
    model: {
      value: (_vm.AuthModel.etaToPort),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "etaToPort", $$v)
      },
      expression: "AuthModel.etaToPort"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight"
    },
    model: {
      value: (_vm.AuthModel.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "grossWeight", $$v)
      },
      expression: "AuthModel.grossWeight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Local IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "localIgmNo",
      "name": "localIgmNo"
    },
    model: {
      value: (_vm.AuthModel.localIgmNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "localIgmNo", $$v)
      },
      expression: "AuthModel.localIgmNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Local IGM Date.")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a"
    },
    model: {
      value: (_vm.AuthModel.localIgmDate),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "localIgmDate", $$v)
      },
      expression: "AuthModel.localIgmDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No of packages")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "containerSealNo",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.noOfContainer),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "noOfContainer", $$v)
      },
      expression: "AuthModel.noOfContainer"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Actual Consignee")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "consignee",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.consignee),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "consignee", $$v)
      },
      expression: "AuthModel.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Commodity")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "commodity",
    staticStyle: {
      "width": "100% !important"
    },
    model: {
      value: (_vm.AuthModel.commodity),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "commodity", $$v)
      },
      expression: "AuthModel.commodity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo1",
      "name": "mblNo1"
    },
    model: {
      value: (_vm.AuthModel.remarks),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "remarks", $$v)
      },
      expression: "AuthModel.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Invoice Details")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Invoice No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.AuthModel.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "invoiceNo", $$v)
      },
      expression: "AuthModel.invoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Quantity")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "invQuantity",
      "name": "invQuantity"
    },
    model: {
      value: (_vm.AuthModel.invQuantity),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "invQuantity", $$v)
      },
      expression: "AuthModel.invQuantity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "invDescription",
      "name": "invDescription"
    },
    model: {
      value: (_vm.AuthModel.invDescription),
      callback: function($$v) {
        _vm.$set(_vm.AuthModel, "invDescription", $$v)
      },
      expression: "AuthModel.invDescription"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderAuth"
    },
    on: {
      "click": _vm.addAuthDocumentation
    }
  }, [_vm._v("Save & Submit Cargo Notice")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderAuth"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.CargoDocArray.length > 0) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("HAWBL No.")]), _vm._v(" "), _c('th', [_vm._v("Exporter Name")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.CargoDocArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.secondBLNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.exporterName))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-dark",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.viewEditCargo(item)
        }
      }
    }, [_vm._v("\n                                    View / Edit\n                                  ")]), _vm._v(" "), _c('b-button', {
      staticClass: "ml-2",
      attrs: {
        "variant": "outline-dark",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.Print('AIR_IMPORT_CARGO_ARIVAL_NOTIC_PDF', item.uploadCargoDoc)
        }
      }
    }, [_vm._v("\n                                    PDF\n                                  ")])], 1)])
  }))])])]) : _vm._e()])], 1)], 1)], 1)], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopData",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.ProceedSail
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a72588","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airImport/airImportDOorderDocumentation.vue
// module id = 2404
// module chunks = 0